import * as THREE from "three"
import * as RAPIER from "@dimforge/rapier3d-compat"
import { useEffect, useRef, useState } from "react"
import { useFrame, useThree } from "@react-three/fiber"
import { PointerLockControls, useKeyboardControls } from "@react-three/drei"
import { CapsuleCollider, RigidBody, useRapier } from "@react-three/rapier"
import Axe from "./Axe"
import { playerStore } from "./store/player.store"
import { observer } from "mobx-react"
import { gsap } from "gsap"

const SPEED = 5
const frontVector = new THREE.Vector3()
const sideVector = new THREE.Vector3()

export const Player = observer(() => {
  const [playerPosStatus, setPlayerPosStatus] = useState("kinematicPosition")
  const axe = useRef()
  const ref = useRef()
  const { camera } = useThree()
  const [, get] = useKeyboardControls()


  useEffect(() => {
    if (ref.current && playerStore.isPlayerClick) {
      setTimeout(() => {
        const rigidBody = ref.current;

        gsap.timeline().to(
          { x: -16 }, // Початкова позиція осі X
          {
            x: -12, // Кінцева позиція
            duration: 1.6,
            onUpdate: function () {
              // Оновлюємо позицію об'єкта
              rigidBody.setTranslation({ x: this.targets()[0].x, y: 1.5, z: 7.6 });
            },
          }
        );

        setTimeout(() => {
          setPlayerPosStatus("dynamic")
        }, 1600)
      }, 200)
    }
  }, [playerStore.isPlayerClick]);


  useFrame((state) => {
    if (!ref.current || !axe.current || playerStore.isInPosition || playerStore.isInForm) return
    const { forward, backward, left, right, jump } = get()

    const velocity = ref.current.linvel()
    // update camera
    const pos = {...ref.current.translation()}
    camera.position.set(pos.x, pos.y, pos.z)


    // update axe
    axe.current.position.set(pos.x, pos.y, pos.z);


    const direction = new THREE.Vector3();
    camera.getWorldDirection(direction);
    direction.y = 0; // Игнорируем ось Y для нахождения направления на плоскости XZ
    axe.current.rotation.y = -Math.atan2(direction.z, direction.x);

    // movement
    frontVector.set(0, 0, backward - forward)
    sideVector.set(left - right, 0, 0)
    direction.subVectors(frontVector, sideVector).normalize().multiplyScalar(SPEED).applyEuler(camera.rotation)
    ref.current.setLinvel({ x: direction.x, y: velocity.y, z: direction.z })

    // jumping
    /*const ray = new RAPIER.Ray(ref.current.translation(), { x: 0, y: -1, z: 0 });
    const hit = rapier.world.castRay(ray, 1.75); // Кастуємо рей через світ
    const grounded = hit && hit.collider;
    if (jump && grounded) {
      ref.current.setLinvel({ x: 0, y: 4.5, z: 0 });
    }*/
  })

  useEffect(() => {
    if (playerStore.isInPosition) {
      camera.position.set(...playerStore.positionData.currentPosition);
      camera.rotation.set(...playerStore.positionData.currentRotation)
      camera.updateProjectionMatrix();
    }

  }, [playerStore.isInPosition])

  useEffect(() => {
    camera.rotation.y = -1.2
  }, [])



  return (
    <>
      <RigidBody
        canSleep={false}
        ref={ref}
        colliders={false}
        mass={1}
        type={playerPosStatus}
        position={[-16, 1.5, 7.6]}
        enabledRotations={[false, false, false]}
      >
        <CapsuleCollider args={[1, 0.5]} />
      </RigidBody>
      <group ref={axe} scale={playerStore.isInPosition ? [0,0,0] : [1,1,1]}>
        <Axe rotation={[0, Math.PI / 2, 0]} position={[0, -1.6, 0]} />
      </group>
    </>
  )
})
